import React from "react";

const Table = ({ value }) => {
  return (
    <table className="min-w-full border-collapse border border-gray-300 shadow-sm my-4">
      <tbody>
        {value.rows.map((row, index) => (
          <tr
            key={row._key}
            className={index === 0 ? "bg-gray-50" : "hover:bg-gray-50"}
          >
            {row.cells.map((cell, key) =>
              index === 0 ? (
                <th
                  key={key}
                  className="border border-gray-300 px-2 py-2 text-left text-sm font-semibold text-gray-900"
                >
                  {cell}
                </th>
              ) : (
                <td
                  key={key}
                  className="border border-gray-300 px-2 py-2 text-sm text-gray-700"
                >
                  {cell}
                </td>
              )
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
